import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AssignmentRow } from './participated-assignment-card.styles';
import { memo } from 'react';
import { Button, Tag, Tooltip } from 'antd';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import { AssignmentType, SubmissionOverviewStatus } from '@module/assignment';
import { participatedAssignmentTeacher, ParticipatedAssignmentAvailability, ParticipatedAssignmentProgress, ParticipatedAssignmentTiming, ParticipatedAssignmentTypeTag } from './participated-assignment-summary.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ParticipatedAssignmentRow = /*#__PURE__*/memo(function (props) {
  var _item$report$status, _item$report$status2, _item$report$status3;

  var item = props.item,
      now = props.now,
      labels = props.labels,
      disabled = props.disabled,
      onOpen = props.onOpen;
  var teacher = participatedAssignmentTeacher(item, labels);
  var submitted = ((_item$report$status = item.report.status) === null || _item$report$status === void 0 ? void 0 : _item$report$status.id) === SubmissionOverviewStatus.finished.value;
  var banned = ((_item$report$status2 = item.report.status) === null || _item$report$status2 === void 0 ? void 0 : _item$report$status2.id) === SubmissionOverviewStatus.banned.value;
  var overdue = item.isOverdue(now);
  var status = overdue ? 'overdue' : (_item$report$status3 = item.report.status) === null || _item$report$status3 === void 0 ? void 0 : _item$report$status3.id;
  var statusLabel = overdue ? labels.overdue : submitted ? labels.submitted : banned ? labels.banned : labels.ongoing;
  var available = item.canOpen(now);
  return /*#__PURE__*/_jsxs(AssignmentRow, {
    className: "assignment-row",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "assignment-info",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "title-line",
        children: [/*#__PURE__*/_jsx(ParticipatedAssignmentTypeTag, _objectSpread({}, props)), /*#__PURE__*/_jsx(Tooltip, {
          title: item.title,
          children: /*#__PURE__*/_jsx("h2", {
            children: item.title
          })
        }), /*#__PURE__*/_jsxs("span", {
          className: "assignment-code",
          children: ["#", item.idNumber]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "metadata",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: teacher,
          children: /*#__PURE__*/_jsxs("span", {
            className: "assignment-teacher",
            children: [labels.instructor, " ", /*#__PURE__*/_jsx("b", {
              children: teacher
            })]
          })
        }), /*#__PURE__*/_jsx(ParticipatedAssignmentTiming, _objectSpread({}, props))]
      }), /*#__PURE__*/_jsxs("div", {
        className: "badges",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: overdue ? labels.overdueDescription : undefined,
          trigger: ['hover', 'focus'],
          children: /*#__PURE__*/_jsx(Tag, {
            className: "status-badge status-".concat(status),
            icon: submitted ? /*#__PURE__*/_jsx(CheckCircleOutlined, {}) : banned ? /*#__PURE__*/_jsx(StopOutlined, {}) : undefined,
            tabIndex: overdue ? 0 : undefined,
            children: statusLabel
          })
        }), /*#__PURE__*/_jsx(ParticipatedAssignmentProgress, _objectSpread({}, props))]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "assignment-action",
      children: [/*#__PURE__*/_jsx("div", {
        className: "availability",
        children: /*#__PURE__*/_jsx(ParticipatedAssignmentAvailability, _objectSpread({}, props))
      }), /*#__PURE__*/_jsx(Button, {
        type: available && item.type.id === AssignmentType.Examination ? 'primary' : 'default',
        disabled: disabled,
        onClick: function onClick() {
          return onOpen(item);
        },
        "aria-label": "".concat(labels.viewDetails, ": ").concat(item.title),
        children: labels.viewDetails
      })]
    })]
  });
});
ParticipatedAssignmentRow.displayName = 'ParticipatedAssignmentRow';